import React from 'react'
import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { TextField } from '@/ui/form/controls/TextField'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'
const CertificateExhibitor = () => {
  const { t } = useLocalize()
  const {data, setData} = useCertificateStore()
  return (
    <div className="tw-flex tw-gap-4">
      <div className="tw-max-w-[200px] tw-w-full tw-space-y-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
           Wystawiający
          </p>
        </div>
      </div>
      <div className='tw-flex tw-gap-3  tw-w-full'>
        <TextField
          label="Imię i nazwisko"
          placeholder={t('common.type')}
          name="name"
          value={data?.issuer}
          onChange={(e) => setData({ ...data, issuer: e.target.value })}
        />
        <TextField
          label="Stanowisko"
          placeholder={t('common.type')}
          name="name"
          value={data?.position}
          onChange={(e) => setData({ ...data, position: e.target.value })}
        />
      </div>
    </div>
  )
}

export default CertificateExhibitor
